import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Component, ReactNode } from 'react';
import { Sentry } from '../lib/sentry';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    Sentry.withScope((scope) => {
      if (info.componentStack) scope.setExtra('componentStack', info.componentStack);
      Sentry.captureException(error);
    });
  }

  handleReset = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-6 text-center">
          <AlertTriangle className="h-12 w-12 text-red-500" aria-hidden="true" />
          <h1 className="text-xl font-semibold text-slate-900">Algo deu errado</h1>
          <p className="max-w-md text-sm text-slate-600">
            Ocorreu um erro inesperado. Nossa equipe foi notificada. Recarregue a página para tentar
            novamente.
          </p>
          <pre className="max-w-lg overflow-auto rounded-md bg-slate-100 p-3 text-left text-xs text-slate-700">
            {this.state.error.message}
          </pre>
          <button
            type="button"
            onClick={this.handleReset}
            className="inline-flex items-center gap-2 rounded-md bg-violet-600 px-4 py-2 text-sm font-medium text-white hover:bg-violet-700"
          >
            <RefreshCw className="h-4 w-4" aria-hidden="true" />
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
